export default __webpack_public_path__ + "static/media/jmobLogo.c785131f.png";